import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Hero } from "@/components/sections/Hero";
import { Features } from "@/components/sections/Features";
import { StudentJourney } from "@/components/sections/StudentJourney";
import { About } from "@/components/sections/About";
import { Universities } from "@/components/sections/Universities";
import { Vision } from "@/components/sections/Vision";
import { News } from "@/components/sections/News";
import { Contact } from "@/components/sections/Contact";
import { PartnerBanner } from "@/components/sections/PartnerBanner";
import { Seo, breadcrumb, SITE } from "@/components/site/Seo";

export default function Home() {
  return (
    <div className="App min-h-screen bg-white">
      <Seo
        title="OpenDegree — Opening the Door to Higher Education"
        description="OpenDegree is a connected education platform helping learners discover opportunities, access funding and apply to education providers, while helping providers simplify recruitment and admissions."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "OpenDegree — Opening the Door to Higher Education",
          url: `${SITE}/`,
          description: "A connected education platform for learners and education providers.",
          isPartOf: { "@type": "WebSite", name: "OpenDegree", url: `${SITE}/` },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <StudentJourney />
        <About />
        <Universities />
        <Vision />
        <News />
        <Contact />
        <PartnerBanner />
      </main>
      <Footer />
    </div>
  );
}
